import script from "./oftenList.vue?vue&type=script&setup=true&lang=js"
export * from "./oftenList.vue?vue&type=script&setup=true&lang=js"

import "./oftenList.vue?vue&type=style&index=0&id=70217e92&lang=scss"

const __exports__ = script;

export default __exports__